(() => {
  if (customElements.get('rednib-map-consent')) return;
  class MapConsent extends HTMLElement {
    connectedCallback() {
      this.host = this.querySelector('[data-map-frame]');
      this.placeholder = this.querySelector('[data-map-placeholder]');
      this.button = this.querySelector('[data-map-preferences]');
      this.sync = this.sync.bind(this);
      this.openPreferences = this.openPreferences.bind(this);
      this.button.addEventListener('click', this.openPreferences);
      document.addEventListener('visitorConsentCollected', this.sync);
      window.addEventListener('pageshow', this.sync);
      this.timer = window.setInterval(this.sync, 500);
      this.sync();
    }
    disconnectedCallback() {
      window.clearInterval(this.timer);
      document.removeEventListener('visitorConsentCollected', this.sync);
      window.removeEventListener('pageshow', this.sync);
      this.button.removeEventListener('click', this.openPreferences);
      this.host.replaceChildren();
    }
    hasConsent() {
      try {
        const api = window._iub?.cs?.api;
        return api?.isPreferenceExpressed() === true && api.getPreferences()?.purposes?.['3'] === true;
      } catch {
        return false;
      }
    }
    openPreferences() {
      window._iub?.cs?.api?.openPreferences?.();
    }
    sync() {
      const allowed = this.hasConsent();
      if (!allowed) {
        this.host.replaceChildren();
        this.placeholder.hidden = false;
        return;
      }
      if (this.host.childElementCount) return;
      const template = this.querySelector('[data-map-template]');
      const frame = template.content.querySelector('iframe').cloneNode(true);
      frame.classList.add('map');
      this.host.append(frame);
      this.placeholder.hidden = true;
    }
  }
  customElements.define('rednib-map-consent', MapConsent);
})();
